import script from "./InvestmentList.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestmentList.vue?vue&type=script&setup=true&lang=js"

import "./InvestmentList.vue?vue&type=style&index=0&id=e82df7aa&lang=css"

const __exports__ = script;

export default __exports__